<script>
  import data from './data.js'
  let crimes = Object.keys(data["Jan ' 21 to Dec '22"])
  let years = Object.keys(data)
  let YearBeforePrevious = years[years.length - 3]
  let previousYear = years[years.length - 2]
  let latestYear = years[years.length - 1]
  let sources = {
    'Violent crime': 'CSEW',
    'Knife and sharp instruments': 'PRC',
    Homicide: 'PRC',
    Theft: 'CSEW',
    Burglary: 'PRC',
    'Vehicle offences': 'PRC',
    Robbery: 'PRC',
    Fraud: 'CSEW',
    'Computer misuse': 'CSEW',
  }  
  
  let sig = {
    'Violent crime': '[NS]',
    'Knife and sharp instruments': '',
    Homicide: '',
    Theft: "&nbsp[S]",
    Burglary: '',
    'Vehicle offences':'',
    Robbery: '',
    Fraud: '[NS]',
    'Computer misuse': '[NS]',
  }

  let start = {
    'Violent crime': 1981,
    'Knife and sharp instruments': 2011,
    Homicide: 2003,
    Theft: 1981,
    Burglary: 2003,
    'Vehicle offences':2003,
    Robbery: 2003,
    Fraud: 2017,
    'Computer misuse': 2017,
  } 
  console.log(crimes, years, latestYear)

  let sparkHeight = 40

  let makeSpark = (category) => {
    let values = Object.values(data).map((e) => e[category])
    let vMax = Math.max(...values.filter((e) => e !== null))
    let vMin = Math.min(...values.filter((e) => e !== null))
    let vDiff = vMax - vMin
    let output = values.map((e) => (e !== null ? (e - vMin + 1) / vDiff : -1))
    //console.log(vMax, vMin, vDiff, category,values,output)
    return output
  }

  let rows = crimes.map((e) => makeSpark(e))
  console.log('rows', rows)
</script>

<style>
  th {
    color: #206095;
  }
  td {
    height: 20px;
    color: #206095;
    font-size: 14px;
  }
  .labels {
    font-size: 12px;
  }
  .source {
    font-size: 0.8em;
    color: grey;
  }
  .columnHead {
    max-width: 100px;
    text-align: left;
    font-size: 14px;
    vertical-align: bottom;
  }
</style>

<th class="columnHead" />

<table>
  <tr>
    <th class="columnHead" style="text-align:right;padding-right:20px">
      Offence
    </th>

    <th class="columnHead" style="text-align:right; padding-right:20px" colspan="2">
      Number of incidents or offences in YE Dec 2022
    </th>
    
    <th class="columnHead" style="text-align:right;; padding-right:10px">
      Percentage change: YE Dec 2022 compared to YE Mar 2020
    </th>
    <th class="columnHead" style="text-align:right; padding-right:10px">
      Percentage change: YE Dec 2022 compared to YE Dec 2021
    </th>
    <th class="columnHead"  style="text-align:center">Timeline to 2022</th>
    <th class="columnHead" style="padding-left:10px">Source</th>
  </tr>
  <tr />
  {#each crimes as crime, i}
    <tr>

      <td style="text-align:right; padding-right:20px">{crime}</td>

      <td style="text-align:right">
        {(+data[latestYear][crime]).toLocaleString()}
      </td>

      <td style="padding-right:0">
        <svg
          style="overflow:visible"
          height={50}
          width={sparkHeight + 4}>
          <circle
            cx={25}
            cy={25}
            r={Math.sqrt(+data[latestYear][crime] / 20000)}
            fill="#206095" />
        </svg>
      </td>
      <td style="text-align:right">
        {(((data[latestYear][crime] - data[YearBeforePrevious][crime]) / data[YearBeforePrevious][crime]) * 100).toFixed(1)}%
        <span>{@html sig[crime]}</span>
        <span
          style="width:10px; color: #206095; text-align:center;">
          &#9660;
        </span>
      </td>

      <td style="text-align:right">
        {#if Math.abs((data[latestYear][crime] - data[previousYear][crime]) / data[previousYear][crime]) < 1}
          {(((data[latestYear][crime] - data[previousYear][crime]) / data[previousYear][crime]) * 100).toFixed(1)}%
          {#if ((data[latestYear][crime] - data[previousYear][crime]) / data[previousYear][crime])<0}
          <span
            style="width:10px; color: #206095; text-align:center;">
             &#9660;
            
          </span>{/if}
          {#if ((data[latestYear][crime] - data[previousYear][crime]) / data[previousYear][crime])>0} 
          <span
          style="width:10px; color: #F66068; text-align:center;">
          &#9650;
          </span>
          
          {/if}
        {:else}
          N/A
          <span style="width:10px; color:white; text-align:center;">
            &#9660;
          </span>
        {/if}
      </td>
      <td>
        <svg style="overflow:visible" height={sparkHeight} width="150px">
          {#each rows[i] as v, ii}
            {#if v <= 0 || rows[i][ii + 1] < 0}
              <rect
                x={ii * 5.3 - 1}
                y="-2"
                width="5.3"
                height={sparkHeight + 4}
                fill="lightgrey"
                opacity="0.4" />
            {/if}

            {#if (crime=="Theft" || crime=="Violent crime") && ii==0}
            <text
            x={ii * 5.3 - 20}
            y={sparkHeight +12}
            font-size="10px"
            fill="#666">
            {start[crime]}
          </text>            
          <line x1={ii * 5.3 + 3} x2={28 * 5.3} y1={sparkHeight +8} y2={sparkHeight +8} stroke=lightgrey/>

            {/if}

            {#if ( ii==28)}
            <text
            x={ii * 5.3 + 3 }
            y={sparkHeight +12}
            font-size="10px"
            fill="#666">
            2022
          </text>            
            {/if}

            {#if (rows[i][ii + 1] < 0) && (rows[i][ii + 2] > 0) && ii<25}
              <text
                x={ii * 5.3 - 14}
                y={sparkHeight +12}
                font-size="10px"
                fill="#666">
                {start[crime]}
              </text>
            <line x1={ii * 5.3 + 12} x2={28 * 5.3} y1={sparkHeight +8} y2={sparkHeight +8} stroke=lightgrey/>
            {/if}
            {#if rows[i][ii] > -1 && rows[i][ii + 1] > -1 && ii < rows[i].length - 1}
              <line
                x1={ii * 5.3}
                x2={ii * 5.3 + 5.3}
                y1={(1 - v) * sparkHeight}
                y2={(1 - rows[i][ii + 1]) * sparkHeight}
                stroke="#206095"
                stroke-width="3px"
                stroke-linecap="round" />
            {/if}

            {#if ii == rows[i].length - 1}
              <circle
                cx={ii * 5.3}
                cy={(1 - v) * sparkHeight}
                r="2"
                fill="#206095" />
            {/if}
          {/each}
        </svg>
      </td>
      <td style="padding-left:10px">{sources[crime]}</td>
    </tr>
  {/each}
  <tr>
    <td />
    <td />
    <td />
    <td />
    <td />
    <td class="labels">
      <!-- <span>1981</span> -->
      <!-- <span style="float:right">2022</span> -->
    </td>
  </tr>
  <tr>
    <td />
    <td />
    <td />
    <td  class="labels" style="white-space: nowrap;"><span style="padding-left: 10px; overflow: visible;">[S] = significant</span><br><span style="padding-left: 10px; overflow: visible;">[NS] = not significant</span></td>
    <td />
    <td class="labels" style="display: flex; width:150px">
      <svg style="overflow:visible" height={sparkHeight} width="20px">
        <rect
          x="0"
          y={0}
          width="20"
          height={sparkHeight /2}
          fill="lightgrey"
          opacity="0.4" />
      </svg>
      <span style="padding-left:10px; overflow:visible">
        = Comparable data unavailable
      </span>
    </td>
  </tr>
</table><br><br>
<div id="source" style="width:100%; font-weight:bold">Source: Crime Survey for England and Wales (CSEW) from the Office for National Statistics, Police recorded crime (PRC) from the Home Office</div>